import { render, staticRenderFns } from "./connect-how-it-works.vue?vue&type=template&id=2a00acee&scoped=true"
import script from "./connect-how-it-works.vue?vue&type=script&lang=js"
export * from "./connect-how-it-works.vue?vue&type=script&lang=js"
import style0 from "./connect-how-it-works.vue?vue&type=style&index=0&id=2a00acee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00acee",
  null
  
)

export default component.exports